export const PlayIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21" fill="none">
        <path d="M17.7169 8.76697C19.0502 9.53677 19.0503 11.4613 17.7169 12.2311L3.98328 20.1602C2.64994 20.93 0.983273 19.9677 0.983274 18.4281L0.983274 2.5699C0.983274 1.0303 2.64994 0.0680491 3.98327 0.83785L17.7169 8.76697Z" fill="#D9D9D9"/>
        </svg>
    `,
      }}
    />
  );
};
